/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  currentProjectDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
};

@inject('actionDrawerStore')
@observer
export default class EditProjectError extends React.Component<*> {
  render(): React.Node {
    const { t }: TypeProps = this.props;

    return (
      <div className={styles['action-drawer-content']}>
        <div>
          <h3>{t('general:error')}</h3>
        </div>
        {/* No content yet */}
      </div>
    );
  }
}
